import { ProjectType } from "@/consts/Project";
import ProjectDetailBidNoticeDialog from "./ProjectDetailBidNoticeDialog";
import { Button } from "@/components/ui/button";

type Props = {
  type: ProjectType;
  defaultTitle: string;
};

export default function ProjectDetailBidNoticeCard({
  type,
  defaultTitle,
}: Props) {
  const DialogTrigger = () => {
    return (
      <div className="py-2 px-5 bg-dark-brown text-sm text-white font-semibold rounded-sm hover:bg-dark-brown/80 cursor-pointer">
        공고 찾기
      </div>
    );
  };
  return (
    <div className="flex flex-col items-center">
      <div className="h-24 flex flex-col justify-center items-center text-lg text-gray-B font-semibold">
        <p>아직 추가된 공고가 없습니다.</p>
        <p>공고를 추가해보세요</p>
      </div>
      <ProjectDetailBidNoticeDialog
        type={type}
        trigger={<DialogTrigger />}
        defaultTitle={defaultTitle}
      />
    </div>
  );
}
